import React, { Component } from 'react';

const ExampleType = () =>
  <section id="type">
    <h3 className="section-header">Typography</h3>
    <div className="row">
      <div className="columns small-12">
        <h1 className="mega">Mega Header</h1>
        <h1>H1 Header</h1>
        <h2>H2 Header</h2>
        <h3>H3 Header</h3>
        <h4>H4 Header</h4>
        <h5>H5 Header</h5>
      </div>
    </div>
    <div className="row">
      <div className="columns small-12">
        <div className="text-success">Success text</div>
        <div className="text-warning">Warning text</div>
        <div className="text-danger">Danger text</div>
      </div>
    </div>
    <div className="row medium-up-3">
      <div className="column">
        <p>Phosfluorescently leverage existing top-line outsourcing before cost effective methods of empowerment. Assertively transition proactive innovation after worldwide systems. Monotonectally parallel task resource maximizing quality vectors through client-focused opportunities.</p>
        <p>Objectively reintermediate user-centric niche markets whereas backward-compatible services. Competently transform multidisciplinary applications after customer directed interfaces. Progressively evolve B2B bandwidth with highly efficient potentialities.</p>
      </div>
      <div className="column">
        <p>Phosfluorescently leverage existing top-line outsourcing before cost effective methods of empowerment. Assertively transition proactive innovation after worldwide systems. Monotonectally parallel task resource maximizing quality vectors through client-focused opportunities.</p>
        <p>Objectively reintermediate user-centric niche markets whereas backward-compatible services. Competently transform multidisciplinary applications after customer directed interfaces. Progressively evolve B2B bandwidth with highly efficient potentialities.</p>
      </div>
      <div className="column">
        <p>Phosfluorescently leverage existing top-line outsourcing before cost effective methods of empowerment. Assertively transition proactive innovation after worldwide systems. Monotonectally parallel task resource maximizing quality vectors through client-focused opportunities.</p>
        <p>Objectively reintermediate user-centric niche markets whereas backward-compatible services. Competently transform multidisciplinary applications after customer directed interfaces. Progressively evolve B2B bandwidth with highly efficient potentialities.</p>
      </div>
    </div>
    <div className="row">
      <div className="small-16 columns">
        <div className="row">
          <div className="small-16 columns">
            <h3>Spacing</h3>
            <p>We use spacing variables for everything to keep consistent spacing throughout the app. They can be used for any CSS property related to size (with the exception of font size): padding, margins, width, height, positioning.</p>
            <p>Spacing is based on Units (u). All variables are a derivitive of "u", where u currently = 16px.</p>
          </div>
        </div>
        <div className="row medium-up-1">
           <div className="column">
            <h5>$spacing-quarteru</h5>
            <div className="spacing-block spacing-quarter"></div> = 4px
          </div>
          <div className="column">
            <h5>$spacing-halfu</h5>
            <div className="spacing-block spacing-half"></div> = 8px
          </div>
          <div className="column">
            <h5>$spacing-1u</h5>
            <div className="spacing-block spacing-one"></div> = 16px
          </div>
          <div className="column">
            <h5>$spacing-2u</h5>
            <div className="spacing-block spacing-two"></div> = 32px
          </div>
          <div className="column">
            <h5>$spacing-3u</h5>
            <div className="spacing-block spacing-three"></div> = 48px
          </div>
          <div className="column">
            <h5>$spacing-4u</h5>
            <div className="spacing-block spacing-four"></div> = 64px
          </div>
          <div className="column">
            <h5>$spacing-5u</h5>
            <div className="spacing-block spacing-five"></div> = 80px
          </div>
          <div className="column">
            <h5>$spacing-6u</h5>
            <div className="spacing-block spacing-six"></div> = 96px
          </div>
        </div>
      </div>
    </div>
  </section>;

export { ExampleType }



// WEBPACK FOOTER //
// ./styleguide/components/typography.jsx